import {memo} from 'react';

import {Placeholder} from '../components/placeholder.js';
import {
  SelectedItem,
  SelectedItems as SelectedItemsComponent,
} from '../components/selected_items.js';
import {useMultiComboBoxContext} from '../context.js';

type SelectedItemsProps = {
  placeholder?: string;
  className?: string;
};

const SelectedItems = memo(function SelectedItems<T>({
  placeholder = 'Select values',
  className,
}: SelectedItemsProps) {
  const {
    clearable,
    selectedItems,
    removeSelectedItem,
    itemToString,
    getSelectedItemProps,
  } = useMultiComboBoxContext<T>();

  return (
    <SelectedItemsComponent className={className}>
      {selectedItems.length === 0 && <Placeholder text={placeholder} />}
      {selectedItems.map((item, index) => (
        <SelectedItem
          {...getSelectedItemProps({selectedItem: item, index})}
          key={`${itemToString(item)}-${index}-selected`}
          text={itemToString(item)}
          onRemove={
            clearable
              ? () => {
                  removeSelectedItem(item);
                }
              : undefined
          }
        />
      ))}
    </SelectedItemsComponent>
  );
});

export type {SelectedItemsProps};
export {SelectedItems};
